import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/auth";
import secureLocalStorage from "react-secure-storage";
import { ReactNode } from "react";

type ProtectedAdminRouteProps = {
  children: ReactNode;
};

const ProtectedAdminRoute = ({ children }: ProtectedAdminRouteProps) => {
  const { user } = useAuth();

  const token: any = secureLocalStorage.getItem("access_token");
  if (!token) return <Navigate to="/" replace />;

  const profile = user?.profile;

  if (profile === "usuarioFornecedor") {
    return <Navigate to="/home" replace />;
  }

  const isAdmin =
    profile === "adminUnidade" || profile === "superAdmin";

  if (!isAdmin) return <Navigate to="/home" replace />;

  return <>{children}</>;
};

export default ProtectedAdminRoute;
